import settingsReducer from "./reducers";
export { default as Settings } from "./SettingsComponent";
export { default as settingsOperations } from "./operations";
export default settingsReducer;
